// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"f6b96313","605":"33bc59af"}[chunkId] + ".chunk.js";
};